import { render, staticRenderFns } from "./ShopNotAvailable.vue?vue&type=template&id=c8479098&scoped=true"
import script from "./ShopNotAvailable.vue?vue&type=script&lang=js"
export * from "./ShopNotAvailable.vue?vue&type=script&lang=js"
import style0 from "./ShopNotAvailable.vue?vue&type=style&index=0&id=c8479098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8479098",
  null
  
)

export default component.exports